import React from 'react';
import AccessViewDefaultAlert from './AccessViewDefaultAlert';
import AccessViewDescription from './AccessViewDescription';
import AccessViewTable from './AccessViewTable';
import PropTypes from 'prop-types';

const AccessView = ({ resetDefaultBranch }) => {
    return (
        <div className="access-view container-fluid">
            <AccessViewDefaultAlert resetDefaultBranch={resetDefaultBranch} />
            <AccessViewDescription />
            <AccessViewTable />
        </div>
    );
};

AccessView.propTypes = {
    resetDefaultBranch: PropTypes.bool,
};

AccessView.defaultProps = {
    resetDefaultBranch: false,
};

export default AccessView;
